import type { PackagingSetV2, Partner, PartnerPackagingV2 } from './types';
import type { User } from '../AuthService/types';

export const mockUser: User = {
  userId: '8cb8e11d-fbd6-42a7-b369-613fb843179b',
  sessionPartnerId: 'fa435948-b377-4aa8-b68a-dcf63a9b1ab3',
  email: 'mac@justgreatcables.com',
  active: true,
  givenName: 'Mac',
  surname: 'Brown',
  sessionPartnerName: 'Just Great Cables',
  sessionPartnerRole: 'administrator',
  sessionPartnerUrl: 'just-great-cables',
};

export const mockPartner: Partner = {
  partnerId: 'fa435948-b377-4aa8-b68a-dcf63a9b1ab3',
  countryCode: 'USA',
  name: 'Just Great Cables',
  type: 'retailer',
  costingConfigurationInfo: {
    costCurrency: 'USD',
    upgradeOverCheapestCostTolerance: 5.5,
    totalUpgradeCostTolerance: 20.0,
  },
  securityConfigurationInfo: {
    passwordConfigurationInfo: {
      accountLockoutEnabled: true,
      changesBeforeRepeatsAllowedCount: 0,
      expirationDuration: 'string',
      failedLoginsBeforeLockoutCount: 0,
      lockoutDuration: 'string',
      passwordExpirationEnabled: true,
      repeatPasswordEnforcementEnabled: true,
    },
  },
  featureConfigurationInfo: {},
  featureToggles: {},
  returnsServiceMethods: [
    {
      active: true,
      carrierId: 'ups',
      carrierServiceMethodId: 'ups-returns-service-method',
      labelProperties: {
        dpi: 203,
        width: 6,
        height: 4,
        labelOrientation: 'rotate_0',
        linearUnits: 'in',
      },
      labelAugmentations: [
        {
          zpl: `
      ^XA
      ^FO50,60^A0,40^FDWorld's Best Returned Griddle _GRIDDLE-ID_ ^FS
      ^FO60,120^BY3^BCN,60,,,,A^FD1234ABC^FS
      ^FO25,25^GB380,200,2^FS
      ^XZ
      `,
          labelImage:
            'data:image/png;base64,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',
          shipmentTagToMatch: 'Returns',
          name: 'Return Augmentation 1',
        },
      ],
      credentialDefinition: {
        credentialStructureId: 'ups-stanard-creds',
        credentials: {
          'ups-api-key': 'apikey123',
          'ups-api-username': 'ups_user',
          'ups-api-password': 'upspassword',
        },
      },
      name: 'UPS Returns',
      testMode: true,
    },
  ],
  pageViewEstimates: {
    daily: {
      average: 1000,
      peak: 2000,
    },
  },
  reportingConfigurationInfo: {
    orderToDeliverSlaDays: 0,
    orderToShipSlaDays: 0,
  },
  auditInfo: {
    createdBy: 'mock-user-guid',
    creationTimeStamp: new Date().toISOString(),
    lastUpdatedTimeStamp: new Date().toISOString(),
    lastUpdatedBy: 'mock-user-guid',
    version: 1,
  },
};

export const mockPackagingV2: PartnerPackagingV2[] = [
  {
    name: 'test-name',
    archived: false,
    active: false,
    linearDimensions: {
      height: 0.5,
      length: 8,
      width: 2,
      linearUnit: 'in',
    },
    maxContentWeight: {
      weight: 10,
      weightUnit: 'lb',
    },
    packagingId: '657ae528-5463-4681-8276-533423f0d03d',
    packagingSizeName: 'test-package',
    packagingMaterial: 'flat_pack',
    packagingWeight: {
      weight: 0.5,
      weightUnit: 'lb',
    },
    unsupportedProductDetails: [],
  },
  {
    name: 'test-name',
    archived: false,
    active: true,
    linearDimensions: {
      height: 1,
      length: 10,
      width: 4,
      linearUnit: 'in',
    },
    maxContentWeight: {
      weight: 8,
      weightUnit: 'lb',
    },
    packagingId: 'aa1cb4e8-c269-4526-add1-11dfa3bd6e52',
    packagingSizeName: 'test-packaging',
    packagingMaterial: 'box',
    packagingWeight: {
      weight: 0.5,
      weightUnit: 'lb',
    },
    unsupportedProductDetails: [],
  },
];

export const mockPackagingSet: PackagingSetV2[] = [
  {
    name: 'test-name',
    archived: false,
    active: false,
    partnerId: '5',
    packagingSetId: '6',
    urn: '6',
    simulationId: '10',
    description: '5',
    tagIds: ['3'],
    packagingIds: ['5'],
    auditInfo: {
      createdBy: 'mock-user-guid',
      creationTimeStamp: new Date().toISOString(),
      lastUpdatedTimeStamp: new Date().toISOString(),
      lastUpdatedBy: 'mock-user-guid',
      version: 1,
    },
    documentExpiration: '4',
  },
];
